module.exports = __webpack_public_path__ + "fonts/ProximaNova-Semibold.2278178.otf";